import { styled } from '@mui/material/styles';

export const IframeStyled = styled('iframe')`
  min-height: 350px;
`;
